





























































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
@Component({
  components: {
  },
})
export default class TonguePicList extends Vue {
  @Prop()
  private tongues;
  private ifShowPatientDetail: boolean = false;
  private temp: any = {};
  /**
   * @description 切换选中的舌图
   */
  private triggerSelectedTongue(message) {
    this.$emit("trigger", message);
  }
  /**
   * @description 需要刷新
   */
  private refresh() {
    this.$emit("refresh");
  }
}
